export enum UserPermissionTypes {
    //users
    LIST_USERS = "listUsers",
    VIEW_USERS = "viewUsers",
    MODIFY_USERS = "modifyUsers",
    CREATE_USERS = "createUsers",
    //relying parties
    LIST_RELYING_PARTIES = "listRelyingParties",
    VIEW_RELYING_PARTIES = "viewRelyingParties",
    MODIFY_RELYING_PARTIES = "modifyRelyingParties",
    CREATE_RELYING_PARTIES = "createRelyingParties",
    //services
    LIST_SERVICES = "listServices",
    VIEW_SERVICES = "viewServices",
    MODIFY_SERVICES = "modifyServices",
    SUBMIT_SERVICES = "submitServices",
    REVIEW_SERVICES = "reviewServices",
    DEPLOY_SERVICES = "deployServices",
    CREATE_SERVICES = "createServices",
    DELETE_SERVICES = "deleteServices",
    CANCEL_SERVICES = "cancelServices",
    //workflows
    LIST_WORKFLOWS = "listWorkflows",
    VIEW_WORKFLOWS = "viewWorkflows",
    CREATE_WORKFLOWS = "createWorkflows",
    MODIFY_WORKFLOWS = "modifyWorkflows",
    DELETE_WORKFLOWS = "deleteWorkflows",
    SUBMIT_WORKFLOWS = "submitWorkflows",
    CANCEL_WORKFLOWS = "cancelWorkflows",
    REVIEW_WORKFLOWS = "reviewWorkflows",
    DEPLOY_WORKFLOWS = "deployWorkflows",

    //identity providers
    LIST_IDPS = "listIDPs",
    VIEW_IDPS = "viewIDPs",
    MODIFY_IDPS = "modifyIDPs",
    SUBMIT_IDPS = "submitIDPs",
    REVIEW_IDPS = "reviewIDPs",
    DEPLOY_IDPS = "deployIDPs",
    CREATE_IDPS = "createIDPs",
    DELETE_IDPS = "deleteIDPs",
    CANCEL_IDPS = "cancelIDPs",
    //reports
    VIEW_WORKFLOW_USAGE_SUMMARY = "viewWorkflowUsageSummary",
    VIEW_WORKFLOW_USAGE_DETAILS = "viewWorkflowUsageDetails",
    VIEW_USER_ASSERTION_CLAIM_RISK_SUBSET = "viewUserAssertionClaimRiskSubset"
}